// Seizoensplanning per club: op welke maandag week 1 begint en welke kalenderweken
// geen les zijn (vakanties). Opgeslagen in clubs/{clubId}/config/planning als
// { start: "2026-09-07", off: { "2026-10-19": "Herfstvakantie", ... } }.
// Vakantieweken staan op hun maandag-datum, zodat ze op dezelfde plek in de kalender
// blijven als de startdatum verandert. Lesweken tellen gewoon door; een vakantieweek
// schuift alles erna een week op.

var MONTHS = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

export function parseISO(s) {
  if (!s) return null;
  var p = s.split("-").map(Number);
  if (p.length !== 3 || p.some(isNaN)) return null;
  return new Date(p[0], p[1] - 1, p[2]);
}
export function toISO(d) {
  var m = d.getMonth() + 1, day = d.getDate();
  return d.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
}
export function mondayOf(d) {
  var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  var dow = (x.getDay() + 6) % 7; // ma = 0
  return new Date(x.getFullYear(), x.getMonth(), x.getDate() - dow);
}
function addDays(d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); }

export function fmtDay(d) { return d.getDate() + " " + MONTHS[d.getMonth()]; }
export function fmtRange(monday) {
  var sun = addDays(monday, 6);
  if (monday.getMonth() === sun.getMonth()) return "ma " + monday.getDate() + " – zo " + fmtDay(sun);
  return "ma " + fmtDay(monday) + " – zo " + fmtDay(sun);
}

export function hasPlanning(planning) { return !!(planning && parseISO(planning.start)); }

// Kalender vanaf de startweek: één regel per kalenderweek, tot het gevraagde aantal
// lesweken bereikt is. { monday, iso, off, name, week }
export function buildCalendar(planning, lessonWeeks) {
  var rows = [];
  if (!hasPlanning(planning)) return rows;
  var start = mondayOf(parseISO(planning.start));
  var off = planning.off || {};
  var n = 0;
  for (var i = 0; n < lessonWeeks && i < 120; i++) {
    var m = addDays(start, i * 7);
    var iso = toISO(m);
    var isOff = Object.prototype.hasOwnProperty.call(off, iso);
    if (!isOff) n++;
    rows.push({ monday: m, iso: iso, off: isOff, name: isOff ? (off[iso] || "") : "", week: isOff ? null : n });
  }
  return rows;
}

// Maandag van lesweek n (of null zonder planning).
export function mondayOfWeek(planning, n) {
  var cal = buildCalendar(planning, n);
  var row = cal.find(function (r) { return r.week === n; });
  return row ? row.monday : null;
}

// Welke week hoort bij vandaag?
// status: "now" (lesweek), "vacation" (vakantie, week = eerstvolgende les),
// "before" (seizoen nog niet begonnen, week 1), "after" (seizoen voorbij, laatste week),
// of null zonder planning.
export function currentWeek(planning, lessonWeeks, today) {
  if (!hasPlanning(planning)) return { week: 1, status: null };
  var t = mondayOf(today || new Date());
  var cal = buildCalendar(planning, lessonWeeks);
  if (cal.length === 0) return { week: 1, status: null };
  if (t < cal[0].monday) return { week: 1, status: "before", start: cal[0].monday };
  var idx = cal.findIndex(function (r) { return r.monday.getTime() === t.getTime(); });
  if (idx < 0) return { week: lessonWeeks, status: "after" };
  var row = cal[idx];
  if (!row.off) return { week: row.week, status: "now" };
  var next = cal.slice(idx).find(function (r) { return !r.off; });
  if (!next) return { week: lessonWeeks, status: "after" };
  return { week: next.week, status: "vacation", name: row.name || "Vakantie", nextMonday: next.monday };
}

